<template>
  <app-select v-if="!withTreeselect"
              :multiple="multiple"
              v-model="value"
              :data-title="$t('message.monitoring.message.campaign')"
              :data-menu-heading="$t('message.monitoring.message.campaigns')"
              data-menu-width="auto"
              :data-button-gradient="true"
              :data-items="campaignsList"
              @search="v => search(v)" />

  <app-select v-else
              :data-title="$t('message.monitoring.message.campaign')"
              :data-menu-heading="$t('message.monitoring.message.campaigns')"
              :data-menu-width="dataMenuWidth"
              :data-button-gradient="true"
              @search="v => search(v)">
    <treeselect :value="campaignsIds"
                class="local-filter"
                :normalizer="normalizer"
                :options="list"
                flat
                multiple
                clearable
                always-open
                sort-value-by="INDEX"
                value-consists-of="ALL"
                :noOptionsText="$t('message.generics.message.noOptionsText')"
                @input="emitInput"></treeselect>
  </app-select>
</template>

<script>
import AppSelect from "@components/Select";
import filter from "@mixins/filter";
import loadsOnFilterUpdate from "@mixins/loads-on-filter-update";
import Treeselect from "@riophae/vue-treeselect";
import _ from "lodash";

export default {
  components: {
    AppSelect,
    Treeselect,
  },

  data() {
    return {
      key: "advertising",
      advertisingList: [],
      normalizer(node) {
        return {
          id: node.id,
          label: node.nome,
          children: node.children.length ? node.children : undefined,
        };
      },
      searchText: undefined,
      listWithChildren: [],
      filteredCampaignsList: [],
      internalFilters: {
        archived: false,
        desc: true,
        isLevels: false,
        level: 1,
        orderBy: "data_ultima_alteracao",
        search: "",
        thirdParty: false,
      },
      pagination: {
        amountPerPage: 30,
        page: 0,
      },
    };
  },

  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    withTreeselect: {
      type: Boolean,
      default: false,
    },
    campaignsIds: {
      type: Array,
    },
    menuWidth: {
      type: String,
      required: false,
    },
  },

  computed: {
    campaignsList() {
      return !this.withTreeselect
        ? _.map(this.$store.state.advertising.listToFilter, (advertising) => {
            return {
              id: advertising.id,
              label: advertising.nome,
            };
          })
        : this.listWithChildren;
    },

    filters() {
      return this.$store.state.advertising.filters;
    },
    dataMenuWidth() {
      return this.menuWidth ? this.menuWidth : "auto";
    },
    hasFilteredList() {
      return this.filteredCampaignsList.length > 0;
    },
    list() {
      let list;
      if (!this.searchText) {
        list = this.campaignsList;
      } else if (this.searchText && this.hasFilteredList) {
        list = this.filteredCampaignsList;
      } else if (this.searchText && !this.hasFilteredList) {
        list = [];
      }
      return list;
    },
  },

  methods: {
    load() {
      const payload = {
        pagination: {
          amountPerPage: 10,
        },
        filters: this.filters,
      };

      this.$loader.advertising.listToFilter(payload);
    },

    async loadList() {
      const list = await this.$api.advertising.list({
        filters: this.internalFilters,
        pagination: this.pagination,
      });
      list.map((item) => (item.children = []));
      this.listWithChildren = list;
    },

    search(search) {
      if (!this.withTreeselect) {
        this.$store.commit("ADVERTISING_SET_FILTER", {
          key: "search",
          value: search,
        });
      } else {
        this.searchText = search;
        this.filteredCampaignsList = this.campaignsList.filter((campaign) => {
          return campaign.nome.toLowerCase().includes(search.toLowerCase());
        });
      }
    },

    emitInput(val) {
      this.$emit("input", val);
    },
  },

  async mounted() {
    if (!this.withTreeselect) {
      this.$store.commit("ADVERTISING_SET_FILTER", {
        key: "search",
        value: "",
      });
    } else {
      await this.loadList();
    }
  },

  mixins: [filter, loadsOnFilterUpdate],
};
</script>

<style scoped>
</style>

